import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaAfaSuper = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar title="Vista Afa Super(Shotcrete Accelerator)" />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          title="Description"
          imageUrl={imgnotavailableImg}
          content="Dr Vista AFA Super is an alkali free accelerator especially used for wet shotcrete applications. 
          It starts up a sudden drop of slump and a thixotropic effect at the time of spraying. The reaction with cement particles is immediate. 
          Dr Vista AFA Super can be used in combination with Dr Vista superplasticizers."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Develops early high strength.",
                "Does not contain any chloride which causes corrosion of steel.",
                "Dr Vista AFA Super is an alkali free accelerator especially used for wet shotcrete applications. It starts up a sudden drop of slump and a thixotropic effect at the time of spraying. The reaction with cement particles is immediate. Dr Vista AFA Super can be used in combination with Dr Vista superplasticizers."
              ],
              [
                "Speeds up the work and contributes to good water tightness of the sprayed concrete lining.",
                "Improves overhead spray and reduces rebound."
              ]
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area of Application">
          <CustomLists
            items={[
              [
                "Mines",
                "Shotcrete",
                "Protection of shafts"
              ],
              [
                "Tunnels, shafts",
                "Rock & Slope Stabilisation",
                "Tank linings"
              ]
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
        <div className="overflow-x-auto min-w-[800px] w-full max-w-4xl mx-auto">
          <Table
            items={{
              headings: [],
              rows: [
                ["Appearence / Color", "Off White Liquid"],
                ["Relative Density", "1.44 ± 0.03"],
                ["pH value", "2.5 ± 0.5"],
                ["Chloride Content", "0.1%"],
                ["Alkali Content", "1%/B"],
              ]
            }}
          />
          </div>
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaAfaSuper;
